export enum LinkListLengths {
  LIST_1 = 22,
  LIST_2 = 15,
  LIST_3 = 6,
}

export enum FooterStrings {
  COPYRIGHT = '© Copyright TfL',
}
